<template>
  <div>
    <label class="form-label"
      >{{ $t('Chave Pix') }}:
      <font-awesome-icon v-if="showInfo" :icon="['fas', 'question-circle']" v-b-tooltip.hover :title="msgInfo"
    /></label>
    <b-input
      :disabled="disabled"
      type="text"
      v-model="pixKey"
      :placeholder="$t('Digite sua chave PIX')"
      @input="validatePixKey"
      @blur="applyMask"
    />
    <span v-if="pixTypeId == null && pixKey" class="text-danger">{{ $t('Chave Pix invalida') }}</span>
  </div>
</template>

<script>
import i18n from '@/i18n';
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    chavePix: {
      type: String,
      default: ''
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    msgInfo: {
      type: String,
      default: i18n.t('Chave Pix será enviada para o cadastro do Estabelecimento no ERP')
    }
  },
  data() {
    return {
      pixKey: this.chavePix,
      pixTypeId: null
    };
  },
  watch: {
    chavePix(newVal) {
      if (newVal !== this.pixKey) {
        this.pixKey = newVal;
        this.validatePixKey();
        this.applyMask();
      }
    }
  },
  methods: {
    validatePixKey() {
      let key = this.pixKey.replace(/\D/g, '').trim();
      let keyEmail = this.pixKey.trim();

      // ID - Type
      //  1 - Email
      //  2 - Chave Aleatória
      //  3 - CNPJ
      //  4 - CPF
      //  5 - Celular

      if (this.$util.isValidCPF(key)) {
        this.pixTypeId = 4;
      } else if (this.$util.isValidCNPJ(key)) {
        this.pixTypeId = 3;
      } else if (/^\d{11}$/.test(key) && /^[2-9]/.test(key)) {
        this.pixTypeId = 5;
      } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(keyEmail)) {
        this.pixTypeId = 1;
      } else if (
        /^([0-9a-fA-F]{32}|[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89aAbB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$/.test(
          this.pixKey
        )
      ) {
        this.pixTypeId = 2;
      } else {
        this.pixTypeId = null;
      }

      this.$emit('updateChavePix', this.pixKey, this.pixTypeId);
    },
    applyMask() {
      let formattedValue = this.pixKey.replace(/\D/g, '');

      // Aplica a máscara de CPF
      if (this.pixTypeId === 4 && formattedValue.length === 11) {
        this.pixKey = formattedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
      // Aplica a máscara de CNPJ
      else if (this.pixTypeId === 3 && formattedValue.length === 14) {
        this.pixKey = formattedValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      // Aplica a máscara de Chave Aleatória
      else if (this.pixTypeId === 2 && this.pixKey.length === 32) {
        this.pixKey = this.pixKey.replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/, '$1-$2-$3-$4-$5');
      }
      // Aplica a máscara de Telefone
      else if (this.pixTypeId === 5 && formattedValue.length === 11) {
        this.pixKey = formattedValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }
    }
  }
};
</script>
